import { Box, CardContent, Typography, MenuItem, Select } from "@mui/material";
import Card from "@mui/material/Card";
import SentimentSatisfiedIcon from "@mui/icons-material/SentimentSatisfied";
import { useState } from "react";

export default function TimelineCard({
  icon = <SentimentSatisfiedIcon />,
  title,
  infos,
}) {
  const [dateFilter, setDateFilter] = useState("last_week");

  return (
    <Card
      variant="outlined"
      sx={{
        ml: 2,
        mr: 2,
        mt: 1,
        mb: 1,
        p: 2,
        backgroundColor: "background.default",
      }}
    >
      <CardContent>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
            pb: 2,
          }}
        >
          {/* title of the card */}
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            {title}
          </Typography>

          {/* date filter */}
          <Select
            size="small"
            value={dateFilter}
            onChange={(event) => setDateFilter(event.target.value)}
            sx={{
              minWidth: 220,
              borderRadius: 2,
              backgroundColor: "background.paper",
            }}
          >
            <MenuItem value="today">Oggi</MenuItem>
            <MenuItem value="last_week">Ultima settimana</MenuItem>
            <MenuItem value="last_month">Ultimo mese</MenuItem>
          </Select>
        </Box>

        {/* we map infos to display timeline items */}
        {infos.map((info, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 2,
              mt: 1,
              pb: 1,
              borderBottom: "1px solid",
              borderColor: "divider",
            }}
          >
            {info.value && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Box
                  sx={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    backgroundColor: "text.primary",
                  }}
                />

                <Typography
                  variant="body1"
                  sx={{
                    color: "text.primary",
                    fontWeight: 500,
                  }}
                >
                  {info.value}
                </Typography>
              </Box>
            )}

            {info.time && (
              <Typography variant="body1" sx={{ color: "text.secondary" }}>
                {info.time}
              </Typography>
            )}
          </Box>
        ))}
      </CardContent>
    </Card>
  );
}
